import { useDecision } from '@optimizely/react-sdk'

export const RECIPE_TAGS_CWC_WEB_FLAG = 'turnips_ofx_recipe_tags_cwc_web'

export const useRecipeTagsCwcWeb = () => {
  const [decision] = useDecision(RECIPE_TAGS_CWC_WEB_FLAG)

  return decision.variationKey === 't1'
}
